import axios from 'axios';
export class ExperimentRelayError extends Error {
    constructor(error) {
        const typedError = error instanceof Error ? error : undefined;
        super(typedError?.message || 'Unexpected error.');
        this.isAxiosError = false;
        this.name = typedError?.name || this.name;
        this.stack = typedError?.stack || this.stack;
        this.status = 500;
        if (axios.isAxiosError(typedError)) {
            const axiosError = typedError;
            this.backendResponseData = axiosError.response?.data;
            this.code = axiosError?.code;
            this.errorJSON = axiosError?.toJSON() || undefined;
            this.isAxiosError = true;
            this.status = axiosError?.response?.status || this.status;
        }
    }
}
